module.exports = __webpack_public_path__ + "static/gis_logo-67a9c380c46309c70d6aaffd8ee3137f.png";